import React from 'react';
import { Gift, BookOpen, GraduationCap } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-navy py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <div className="inline-flex items-center justify-center p-3 bg-cyan/10 rounded-full mb-4" data-id="element-4">
            <Gift className="w-8 h-8 text-cyan" data-id="element-5" />
          </div>
          <h2 className="text-3xl md:text-4xl font-headline font-bold text-white uppercase" data-id="element-6">
            Bonos de Acción Rápida <span className="text-cyan" data-id="element-7">(Solo Hoy)</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-8">
          {/* Bonus 1 */}
          <div className="bg-navy-light border border-cyan/20 p-8 rounded-xl relative overflow-hidden group" data-id="element-9">
            <div className="absolute top-0 right-0 bg-cyan text-navy font-bold text-xs px-3 py-1 rounded-bl-lg uppercase" data-id="element-10">
              Bono #1
            </div>
            <div className="flex items-start gap-4" data-id="element-11">
              <div className="bg-navy p-3 rounded-lg border border-white/10" data-id="element-12">
                <BookOpen className="w-6 h-6 text-cyan" data-id="element-13" />
              </div>
              <div data-id="element-14">
                <h3 className="text-xl font-headline font-bold text-white mb-2 group-hover:text-cyan transition-colors" data-id="element-15">
                  Checklist de Día de Tryout
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-16">
                  Qué debe comer, decir y hacer tu hijo 24 horas antes de la
                  prueba más importante de su vida.
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-navy-light border border-cyan/20 p-8 rounded-xl relative overflow-hidden group" data-id="element-17">
            <div className="absolute top-0 right-0 bg-cyan text-navy font-bold text-xs px-3 py-1 rounded-bl-lg uppercase" data-id="element-18">
              Bono #2
            </div>
            <div className="flex items-start gap-4" data-id="element-19">
              <div className="bg-navy p-3 rounded-lg border border-white/10" data-id="element-20">
                <GraduationCap className="w-6 h-6 text-cyan" data-id="element-21" />
              </div>
              <div data-id="element-22">
                <h3 className="text-xl font-headline font-bold text-white mb-2 group-hover:text-cyan transition-colors" data-id="element-23">
                  Guía de Becas y GPA
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-24">
                  El secreto sucio del fútbol en USA: Si no tiene estas notas,
                  su talento vale cero para las universidades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}